import '../../assets/styles/report.scss';

import { REPORT_SERVICES, IMG } from '../../const';

const tabButtons = [
  { id: 1, value: 'Fastest & Affordable', cost: '€25,6–29,4K' },
  { id: 2, value: 'Fastest & Affordable', cost: '€25,6–29,4K' },
  { id: 3, value: 'Fastest & Affordable', cost: '€25,6–29,4K' },
  { id: 4, value: 'Fastest & Affordable', cost: '€25,6–29,4K' },
  { id: 5, value: 'Fastest & Affordable', cost: '€25,6–29,4K' },
];

const EmptyReport = () => (
  <div className="report-page">
    <div className="report-page__heading-sticky">
      <div className={`report-page__heading`}>
        <div>
          <h1>
            Check <strong>your estimations</strong>
          </h1>
          <p>We’ve carefully analyzed your responses and calculated</p>
          <div className="copy-link-btn__wrapper">
            <button type="button" className="copy-link-btn ic-copy-link">
              <div className={`copy-link-btn__tooltip`}>Copy report link</div>
            </button>
          </div>
        </div>
        <div className="report-page__heading__link-wrapper">
          <div className="primaryFatLink ic-consultation">
            Book free consultation
          </div>
          <p>to get 100% accuracy estimations</p>
        </div>
      </div>

      <div className={`options-fieldset`}>
        <legend>Choose an option:</legend>
        <div className="options-wrapper">
          <div>
            {tabButtons.map((option) => (
              <div key={option.id} className="option-btn-group">
                <button type="button" id={option.id} className={`ic-check`}>
                  {option.value}
                  <span>{option.cost}</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div>
      <section className="report-page__tabs-block" id="report-tabs--js">
        <div className={`report-page__tab  activeTab`}>
          <div className="summary-block">
            <div className="summary-block__label">Summary</div>
            <ul className="summary-block__list">
              <li>
                <div>70%</div>
                <div>accuracy</div>
              </li>
              <li>
                <div>3</div>
                <div>people in team</div>
              </li>
              <li>
                <div>€25,6–29,4K</div>
                <div>budget range</div>
              </li>
              <li>
                <div>9-11</div>
                <div>weeks</div>
              </li>
            </ul>
          </div>

          <div className="features-block">
            <div className="features-block__item">
              <div className="features-block__item-title">Key Features</div>
              <ul>
                <li>1 Project Manager (part-time)</li>
                <li>1 Full-stack Developer</li>
                <li>1 QA Engineer (part-time)</li>
                <li>1 UI/UX Designer</li>
              </ul>
            </div>

            <div className="features-block__item height-fit-content">
              <div className="features-block__item-title">Team</div>
              <ul>
                <li>1 Project Manager (part-time)</li>
                <li>1 Full-stack Developer</li>
                <li>1 QA Engineer (part-time)</li>
                <li>1 UI/UX Designer</li>
              </ul>
            </div>
          </div>

          <div className="summary-block">
            <div className="summary-block__label">Roadmap</div>
            <ul className="summary-block__roadmap">
              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/call-calling.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="Book Free consultation"
                  />
                  <div>
                    <h3>Book Free consultation</h3>
                    <p>
                      A quick intro call to understand your needs, goals, and
                      whether we're the right fit.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">45 min</div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/search-status.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System Discovery and Specification"
                  />
                  <div>
                    <h3>System Discovery and Specification</h3>
                    <p>
                      Research and validation phase: interviews, competitor
                      analysis, business goals clarification. Helps define the
                      “why” and ensure alignment before solutioning.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">10-15 days</div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/brush.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="UI/UX Design"
                  />
                  <div>
                    <h3>UI/UX Design</h3>
                    <p>
                      Design team creates UX flows, high-fidelity UI, and
                      interactive prototypes to visualize the product experience
                      and validate before development.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">36-43 days</div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/code.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System development"
                  />
                  <div>
                    <h3>System development</h3>
                    <p>
                      Developers begin building the project following the
                      approved scope and designs, often in iterative sprints.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">46-45 days</div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/share.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System Improvement/Knowledge sharing"
                  />
                  <div>
                    <h3>System Improvement/Knowledge sharing</h3>
                    <p>
                      Post-launch activities: bug fixes, user feedback
                      collection, QA testing, and performance optimization.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">9-18 days</div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>

    <section className="services-section">
      <h2>
        Services that <strong>match</strong> your goals
      </h2>
      <p>
        Learn about the services the project may include to align with your
        business goals.
      </p>
      <div className="services-list__wrapper">
        <ul className="services-list">
          {REPORT_SERVICES.map((service) => (
            <li key={service.id} className="services-list__item">
              <div>
                <picture>
                  <source
                    srcSet={`${IMG.QUICK_QUOTE}/${service.image}.avif`}
                    type="image/avif"
                  />
                  <source
                    srcSet={`${IMG.QUICK_QUOTE}/${service.image}.webp`}
                    type="image/webp"
                  />
                  <source
                    srcSet={`${IMG.QUICK_QUOTE}/${service.image}.png`}
                    type="image/png"
                  />
                  <img
                    src={`${service.image}.png`}
                    width="190"
                    height="196"
                    alt={service.title}
                    loading="lazy"
                  />
                </picture>
              </div>
              <div>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </div>
              <a
                className="services-list__item-link"
                href={service.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                See more details
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className="about-section">
      <div>
        <h2>
          About our <strong>company</strong>
        </h2>
        <p>
          Let’s develop a software product based on your unique idea and our 10+
          years of expertise.
        </p>
        <div className="about-section__text">
          <p>
            At LaSoft, we turn complex product ideas into scalable, intelligent
            digital solutions.
          </p>
          <p>
            Our cross-functional teams work with enterprises, SMBs, and startups
            to empower clients across industries like logistics, healthcare,
            finance, HR, education, and more.
          </p>
          <p>
            As an experienced software development partner, we&nbsp;specialize
            in AI-powered platforms, cloud infrastructure, data visualization,
            and custom software&nbsp;development.
          </p>
        </div>
      </div>
      <div className="counters-block">
        <ul className="counters-block__list"></ul>
      </div>
    </section>
  </div>
);

export default EmptyReport;
